var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Mechanism" },
    [
      _c(
        "ApplySlotGroup",
        { on: { saveData: _vm.saveData } },
        [
          _c(
            "div",
            { staticClass: "Mechanism-top" },
            [
              _c(
                "el-checkbox",
                { attrs: { label: "1" }, on: { change: _vm.workTypeChange } },
                [_vm._v("我是办事处")]
              ),
              _c(
                "el-form",
                { staticClass: "Form-style" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "Company-name",
                      attrs: { label: "公司名称" },
                    },
                    [
                      _c("el-autocomplete", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请输入公司名称",
                          "fetch-suggestions": _vm.querySearchCompany,
                        },
                        on: { select: _vm.handleSelectCompany },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", [_vm._v(_vm._s(scope.item.name))]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.dataForm.mechanismName,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "mechanismName", $$v)
                          },
                          expression: "dataForm.mechanismName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "注册国家" } },
                    [
                      _c("el-autocomplete", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请输入注册国家",
                          "fetch-suggestions":
                            _vm.querySearchCountryRegistration,
                        },
                        on: { select: _vm.handleSelectCountryRegistration },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(scope.item.countryNameCn)),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.dataForm.countryRegistration,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "countryRegistration", $$v)
                          },
                          expression: "dataForm.countryRegistration",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "注册城市" } },
                    [
                      _c("el-autocomplete", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请输入注册城市",
                          "fetch-suggestions": _vm.querySearchCityRegistration,
                        },
                        on: { select: _vm.handleSelectCityRegistration },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(scope.item.cityNameCn)),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.dataForm.cityRegistration,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "cityRegistration", $$v)
                          },
                          expression: "dataForm.cityRegistration",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公司类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择公司类型" },
                          model: {
                            value: _vm.dataForm.companyType,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "companyType", $$v)
                            },
                            expression: "dataForm.companyType",
                          },
                        },
                        _vm._l(_vm.companyTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "经营范围" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入公司经营范围" },
                        model: {
                          value: _vm.dataForm.natureBusiness,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "natureBusiness", $$v)
                          },
                          expression: "dataForm.natureBusiness",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "注册地址" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入公司注册地址" },
                        model: {
                          value: _vm.dataForm.adressRegistration,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "adressRegistration", $$v)
                          },
                          expression: "dataForm.adressRegistration",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.dataForm.workType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "注册国家（办事处）" } },
                        [
                          _c("el-autocomplete", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请输入注册国家",
                              "fetch-suggestions": _vm.querySearchCountryWork,
                            },
                            on: { select: _vm.handleSelectCountryWork },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(scope.item.countryNameCn)
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1589351212
                            ),
                            model: {
                              value: _vm.dataForm.countryWork,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "countryWork", $$v)
                              },
                              expression: "dataForm.countryWork",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataForm.workType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "注册城市（办事处）" } },
                        [
                          _c("el-autocomplete", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请输入注册城市",
                              "fetch-suggestions": _vm.querySearchCityWork,
                            },
                            on: { select: _vm.handleSelectCityWork },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", [
                                        _vm._v(_vm._s(scope.item.cityNameCn)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4010726851
                            ),
                            model: {
                              value: _vm.dataForm.cityWork,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "cityWork", $$v)
                              },
                              expression: "dataForm.cityWork",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataForm.workType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "注册地址（办事处）" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入注册地址" },
                            model: {
                              value: _vm.dataForm.adressWork,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "adressWork", $$v)
                              },
                              expression: "dataForm.adressWork",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公司营业执照有效期" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": "-",
                          "value-format": "yyyy-MM-dd",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        on: { change: _vm.dataChange },
                        model: {
                          value: _vm.dataArr,
                          callback: function ($$v) {
                            _vm.dataArr = $$v
                          },
                          expression: "dataArr",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        "flex-direction": "column",
                        "padding-bottom": "15px",
                      },
                      attrs: { label: "公司营业执照" },
                    },
                    [
                      _c("wintac-upload", {
                        attrs: {
                          imgName: "营业执照",
                          pid: _vm.pid,
                          state: 0,
                          env: "user",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "Company-introduction",
                      attrs: { label: "公司简介" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "9rem" },
                        attrs: {
                          type: "textarea",
                          rows: 5,
                          placeholder: "请填写公司简介",
                        },
                        model: {
                          value: _vm.dataForm.introduce,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "introduce", $$v)
                          },
                          expression: "dataForm.introduce",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "supplier-checkTabs" }, [
            _c(
              "span",
              {
                class: _vm.checkTabs === 1 ? "checkTabs-isActive" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeTabs(1)
                  },
                },
              },
              [_vm._v("业务联系人")]
            ),
            _c(
              "span",
              {
                class: _vm.checkTabs === 2 ? "checkTabs-isActive" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeTabs(2)
                  },
                },
              },
              [_vm._v("收款账户")]
            ),
            _c(
              "span",
              {
                class: _vm.checkTabs === 3 ? "checkTabs-isActive" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeTabs(3)
                  },
                },
              },
              [_vm._v("法人信息")]
            ),
            _c(
              "span",
              {
                class: _vm.checkTabs === 4 ? "checkTabs-isActive" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeTabs(4)
                  },
                },
              },
              [_vm._v("信息设置")]
            ),
          ]),
          _c("businessContact", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.checkTabs == 1,
                expression: "checkTabs==1",
              },
            ],
          }),
          _c("collection", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.checkTabs == 2,
                expression: "checkTabs==2",
              },
            ],
            attrs: { supplierType: 0 },
          }),
          _c("legalInfo", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.checkTabs == 3,
                expression: "checkTabs==3",
              },
            ],
          }),
          _c("automatic", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.checkTabs == 4,
                expression: "checkTabs==4",
              },
            ],
          }),
          _c("AreaSelect"),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "productTypeDialog",
          attrs: {
            title: "入驻审核提示",
            "custom-class": "customProduct",
            visible: _vm.applyShow,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.applyShow = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-top" }, [
            _c("span", [_vm._v("入驻审核提示")]),
          ]),
          _c("div", { staticClass: "applets-style" }, [
            _c("p", [
              _vm._v("亲，你的"),
              _c("b", [_vm._v("申请已经提交")]),
              _vm._v("，我们将在24小时内审核，请您"),
              _c("b", [_vm._v("关注下方二维码")]),
              _vm._v(
                "， 在“实用工具'-\"地接圈 账户绑定”内将您的微信和供应商账号绑定， 您将可以及时在线收到审核结果。您也可用您的手机号及密码登录此后台查看审核结果。 若您急需尽快开始使用供应商后台，请您致电我们的紧急 "
              ),
              _c("b", [_vm._v("服务电话 15001256336")]),
              _vm._v("与我们联系， 我们将走特殊审批渠道为您尽快开通账号。 "),
            ]),
            _c(
              "div",
              {
                staticStyle: { "text-align": "center", "padding-top": "30px" },
              },
              [
                _c("img", {
                  attrs: { src: require("@/assets/png/公众号.png"), alt: "" },
                }),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }